import { MODELS } from "./models";
export const MODEL_OPTIONS = [
    {
        key: MODELS.OPUS_4_6,
        text: "Claude Opus 4.6",
        secondaryText: "[recommended]",
        secondaryTextColor: "#1E40AF",
    },
    { key: MODELS.SONNET_4_5, text: "Claude Sonnet 4.5" },
    { key: MODELS.HAIKU_4_5, text: "Claude Haiku 4.5" },
    { key: MODELS.GEMINI_3_PRO, text: "Gemini 3 Pro" },
    { key: MODELS.GEMINI_3_FLASH, text: "Gemini 3 Flash" },
];
export const REASONING_OPTIONS = [
    { key: "HIGH", text: "High" },
    { key: "MEDIUM", text: "Medium" },
    { key: "LOW", text: "Low" },
    { key: "OFF", text: "Off" },
];
export const AWS_REGIONS = [
    { key: "us-east-1", text: "N. Virginia (us-east-1)" },
    { key: "us-east-2", text: "Ohio (us-east-2)" },
    { key: "us-west-1", text: "N. California (us-west-1)" },
    { key: "us-west-2", text: "Oregon (us-west-2)" },
];
export const TABS = [
    { id: "general", label: "General" },
    { id: "carousel-chat", label: "Carousel Chat" },
    //{ id: "quick-fix", label: "Quick Fix" },
    { id: "excel-export", label: "Excel Export" },
    { id: "excel-formatting", label: "Excel Formatting" },
    { id: "indexing", label: "Indexing" },
    // { id: "custom-model-endpoint", label: "Custom Model Endpoint" }, // Hidden for now
    //{ id: "keyboard-shortcuts", label: "Keyboard Shortcuts" },
    //{ id: "model-walkthrough", label: "Model Walkthrough" },
    // { id: "prompt-library", label: "Prompt Library" },
];
export const EDIT_MODE_CHOICES = [
    { value: "clone", label: "CLONE" },
    { value: "original", label: "ORIGINAL" },
];
